import { getAllBuildingCrackList } from "@/api/modelingList.js";
export default {
  namespaced: true,
  state: {
    totalEntityData: {
      rlJoint: [], //节点
      rlGrid: [], //网格
      rlAxis: [], //轴线
      rlBeamSeg: [], //梁
      rlColSeg: [], //柱
      rlRingBeamSeg: [], //圈梁
      rlSlab: [], //楼板
      rlSlabHole: [], //板洞
      rlSubBeam: [], //次梁
      rlWallHole: [], //墙洞
      rlWallSeg: [], //墙
      rlCircle: [], //圆
      rlLine: [], //线
      rlModelNo: [], //构件号文字
      rlText: [], //文本
      rlGridShow: [], //栅格显示
      rlPartitionWallSeg: [], //隔墙
      rlDoorsWindows: [], //门/窗
      rlUse: [], //用途
      rlCantiSlab: [], //悬挑板
      //草图
      rlAxisC: [], //轴线草图
      rlJointC: [], //节点草图
      rlGridC: [], //网格草图
    }, //当前标准层的实体数据集合//,"":[],
    gridShowData: null, //栅格显示数据
    MeasureDrawData: [], //测量绘制数据
    hasCrackGuid: {}, //有裂缝的构件的id
  },
  mutations: {
    //新增栅格显示数据
    addrlGridShowData(state, obj) {
      state.gridShowData = obj;
    },
    //新增实体数据
    addEntityData(state, obj) {
      state.totalEntityData[obj.classTypeName] &&
        state.totalEntityData[obj.classTypeName].push(obj);
      if (typeof window.clearEntityCache === "function") {
        window.clearEntityCache();
      }
    },
    //修改实体数据
    editEntityData(state, obj) {
      for (
        let i = 0;
        i < state.totalEntityData[obj.classTypeName].length;
        i++
      ) {
        let item = state.totalEntityData[obj.classTypeName][i];
        if (item.Guid == obj.Guid) {
          item = obj;
          if (typeof window.invalidateEntityCache === "function") {
            window.invalidateEntityCache(obj.classTypeName, obj.Guid);
          }
          break;
        }
      }
    },
    //删除实体数据
    delEntityData(state, obj) {
      for (
        let i = 0;
        i < state.totalEntityData[obj.classTypeName].length;
        i++
      ) {
        let item = state.totalEntityData[obj.classTypeName][i];
        if (item.Guid == obj.Guid) {
          state.totalEntityData[obj.classTypeName].splice(i, 1);
          if (typeof window.invalidateEntityCache === "function") {
            window.invalidateEntityCache(obj.classTypeName, obj.Guid);
          }
          break;
        }
      }
    },
    //清空某类数据
    clearAnyClassData(state, type) {
      state.totalEntityData[type] = [];
    },
    //清空实体数据
    clearEntityData(state) {
      state.totalEntityData = {
        rlJoint: [],
        rlGrid: [],
        rlAxis: [],
        rlBeamSeg: [],
        rlColSeg: [],
        rlRingBeamSeg: [],
        rlSlab: [],
        rlSlabHole: [],
        rlSubBeam: [],
        rlWallHole: [],
        rlWallSeg: [],
        rlCircle: [],
        rlLine: [],
        rlText: [],
        rlModelNo: [],
        rlPartitionWallSeg: [],
        rlDoorsWindows: [],
        rlUse: [],
        rlCantiSlab: [],
        rlAxisC: [],
        rlJointC: [],
        rlGridC: [],
      };
      if (typeof window.clearEntityCache === "function") {
        window.clearEntityCache();
      }
    },
    //添加测量绘制数据
    addMeasureDrawData(state, obj) {
      state.MeasureDrawData.push(obj);
    },
  },
  actions: {
    async setHasCrackGuid(store, project_id) {
      await getAllBuildingCrackList({
        project_id,
        type: 1,
      }).then((res) => {
        store.state.hasCrackGuid = res.data || {};
      });
    },
  },
  getters: {},
};

//
// store.state.rl_struct_num[key] = {
//   [store.state.rl_stdFlr_id]: {
//     No_: 1,
//     StdFlrGuid: store.state.rl_stdFlr_id,
//   },
// };
